import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ReduxToastr from 'react-redux-toastr';

import Routes from './Routes';

// import '../styles/base.scss';
import '../styles/index.css';
import { withTracker } from './tracker/with-tracker';
import { I18nextProvider } from 'react-i18next';
import i18n from '../i18n';

class App extends Component {
  componentDidMount() {
    if (window !== window.top) {
      if (window.top) {
        window.top.location = window.location.href; // Break out of iframe
      }
    }

    // Ensure only one audio plays at a time across the app
    document.addEventListener('play', this.handleGlobalAudioPlay, true);
  }

  componentWillUnmount() {
    document.removeEventListener('play', this.handleGlobalAudioPlay, true);
  }

  render() {
    return (
      <div>
        <ReduxToastr
          timeOut={4000}
          newestOnTop={false}
          preventDuplicates
          position="top-center"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar={false}
          closeOnToastrClick
        />
        <Routes />
      </div>
    );
  }
  private handleGlobalAudioPlay = (event: Event) => {
    const target = event.target as HTMLMediaElement | null;
    if (!target || !(target instanceof HTMLAudioElement)) return;

    const allAudios = document.querySelectorAll<HTMLAudioElement>('audio');
    allAudios.forEach((audioEl) => {
      if (audioEl !== target && !audioEl.paused) {
        audioEl.pause();
      }
    });
  };
}

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

// without using withRouter, route changes only reflect in url but not on page.
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTracker(App))
);
